import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { MultiSessionLimit, MultiSessionLimits } from "./multi-session-limit.model";

export const ACTION_PREFIX = "[Multi Session Limit]";
export const MULTI_SESSION_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	remove: `${ACTION_PREFIX} Remove`,
	removeSuccess: `${ACTION_PREFIX} Remove Success`,
	removeFail: `${ACTION_PREFIX} Remove Fail`,

	clear: `${ACTION_PREFIX} Clear ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class MultiSessionLimitAction {
	get(): Action {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: MultiSessionLimits): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(error: AppError): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.getFail,
			payload: error,
		};
	}

	update(payload: MultiSessionLimit): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	updateSuccess(payload: MultiSessionLimits): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.updateSuccess,
			payload,
		};
	}

	updateFail(error: AppError): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.updateFail,
			payload: error,
		};
	}

	remove(): Action {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.remove,
		};
	}

	removeSuccess(payload: MultiSessionLimits): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.removeSuccess,
			payload,
		};
	}

	removeFail(error: AppError): ActionWithPayload {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.removeFail,
			payload: error,
		};
	}

	clear(): Action {
		return {
			type: MULTI_SESSION_LIMIT_ACTION_TYPE.clear,
		};
	}
}
